import { createRoot } from "react-dom/client";
import App from "./App.jsx";
import { installAuthInterceptor } from "@/shared/services/httpClient.js";
import { applyStoredTheme } from "./theme.js";
import "./responsive.css";
import "@/shared/styles.css";

// Global async / runtime error capture. Without these, a forgotten
// `.catch()` on any store action silently fails and the user is left
// staring at a stuck UI. Logs go through console.error so they show up
// in dev tools today; once a real error tracker (Sentry/Rollbar) is
// wired in, forward from these handlers to it.
if (typeof window !== "undefined") {
  window.addEventListener("unhandledrejection", (event) => {
    // eslint-disable-next-line no-console
    console.error("[unhandledrejection]", event?.reason);
  });
  window.addEventListener("error", (event) => {
    // eslint-disable-next-line no-console
    console.error("[window.error]", event?.error || event?.message);
  });
}

installAuthInterceptor();
applyStoredTheme();

createRoot(document.getElementById("root")).render(<App />);
